export const getSiteLink = (site) =>
  site?.linkLocation?.id || site?.linkLocation?.url || site?.slug
